import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';

import {Auth} from '@aws-amplify/auth';

// async function getTokens() {
//   debugger;
//   const user = await Auth.currentAuthenticatedUser();
//   const {idToken, accessToken} = user.signInUserSession;
//   return {idToken: idToken.jwtToken, accessToken: accessToken.jwtToken};
// }

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        'X-ID-Token': `Bearer ${sessionStorage.getItem('idToken')}`,
      }
    });
    return next.handle(request);
  }

  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   return from(Auth.currentAuthenticatedUser()).pipe(
  //     mergeMap(async (user) => {
  //       debugger;
  //       const { idToken, accessToken } = user.signInUserSession;
  //
  //       request = request.clone({
  //         setHeaders: {
  //           Authorization: `Bearer ${accessToken.jwtToken}`,
  //           'X-ID-Token': idToken?.jwtToken || '',
  //         },
  //       });
  //
  //       return next.handle(request).toPromise();
  //     })
  //   );
  // }
}

// import {
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
// } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable, from } from 'rxjs';
// import { switchMap } from 'rxjs/operators';
// import { IUser, CognitoService } from '../cognito.service';
//
// @Injectable()
// export class TokenInterceptor implements HttpInterceptor {
//   constructor(private readonly _cognitoService: CognitoService) {}
//
//   intercept(
//     req: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     debugger;
//     //
//     return from(this._cognitoService.getSession()).pipe(
//       switchMap((session) => {
//         debugger;
//         let jwttoken = req.clone({
//           setHeaders: {
//             Authorization: 'Bearer ' + session.accessToken.jwtToken,
//           },
//         });
//         return next.handle(jwttoken);
//       })
//     );
//   }
// }
